import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(({ spacing, mixins }) => ({
  globalSearchPopper: {
    width: "100% !important",
    maxWidth: "360px"
  },
  globalSearchListbox: {
    padding: spacing(0),
    scrollbarWidth: "auto",
    scrollbarColor: "auto"
  },
  globalSearchInputRoot: {
    minWidth: "260px !important",

    [`&.Mui-focused`]: {
      ...mixins.focusRing.shadow
    }
  }
}))
